var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiObserveVisibility',{on:{"visible":_vm.processViewAdd}},[_c('div',{class:_vm.$style['sparrow-block'],attrs:{"data-adv-sparrow":"1"},domProps:{"innerHTML":_vm._s(_vm.widgetScript)}})])}
var staticRenderFns = []

export { render, staticRenderFns }